import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex text-black items-center h-full modal-title"
}
const _hoisted_2 = ["contenteditable"]
const _hoisted_3 = {
  key: 0,
  class: "flex items-center text-black toolbar-center-item normal-title"
}
const _hoisted_4 = ["contenteditable"]
const _hoisted_5 = {
  key: 0,
  class: "flex absolute h-3 w-3 top-0 right-0 -mt-1 -mr-1 z-10"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-600 opacity-75" }, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "relative inline-flex rounded-full h-3 w-3 bg-yellow-600" }, null, -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

import '@gohighlevel/ghl-ui/dist/style.css'
import {
  UIContentWrap,
  UIButton,
  UIToolbar,
  UIToolbarGroup,
  UIActionDropdown,
} from '@gohighlevel/ghl-ui'
import {
  EyeIcon,
  XCloseIcon,
  Edit01Icon,
  ArrowLeftIcon,
  Send03Icon,
  UserCircleIcon,
} from '@gohighlevel/ghl-icons/24/outline'
import { useRoute } from 'vue-router'
import { builderState } from './../composable/manageBuilderState'
import { debounce } from 'lodash'
import { computed, ref, watch, watchEffect } from 'vue'
import i18n from 'common/locales'
import { appState } from '../composable/appState'


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
  id: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: 'Email Template',
  },
  unsavedChanges: {
    type: Boolean,
    default: false,
  },
  contentEditable: {
    type: Boolean,
    default: false,
  },
  isModal: {
    type: Boolean,
    default: false,
  },
  backTitle: {
    type: String,
    default: 'Back',
  },
  menuOptions: {
    type: Array<any>,
    default: [],
  },
  disableRestore: {
    type: Boolean,
    default: false,
  },
  showCloneTemplate: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  'model:close',
  'title:update',
  'route:back',
  'menu:click',
  'save:click',
  'version:restore',
  'schedule:click',
  'saveAsTemplate:click',
  'contact:click',
  'campaign:send',
  'campaign:save',
],
  setup(__props, { emit: __emit }) {

const route = useRoute()

const currentPageName = ref<string>(route?.name)
if (!currentPageName.value && appState.isEmailPreviewApp) {
  currentPageName.value = appState.selectedPage
}

const routeName = computed(() => route?.name)

watch(
  () => appState.selectedPage,
  (newVal, oldVal) => {
    if (newVal) currentPageName.value = newVal as string
  }
)

watchEffect(() => {
  if (routeName.value) currentPageName.value = routeName.value as string
})

const headerMenuOptions = computed(() =>
  props?.menuOptions?.map(item => ({
    label: item?.name,
    key: item?.id,
    icon: item?.newIcon,
  }))
)
const isBuilder = computed(
  () =>
    currentPageName.value === 'builder' ||
    currentPageName.value == 'email_edit_campaign'
)
const saveTitle = computed(() =>
  props.isModal ||
  currentPageName.value === 'email_edit_campaign' ||
  currentPageName.value === 'email_schedule_campaign'
    ? i18n.global.t('common.save')
    : i18n.global.t('emailTemplate.saveTemplate')
)
const editTitle = ref(false)
const props = __props
const emit = __emit
// adding component level ref to avoid rendering issue with title
const titleText = ref(props.title)
const defaultCampaignName = i18n.global.t('emailCampaign.untitledCampaignName')
watch(
  () => props.title,
  newVal => {
    if (!titleText.value || props.title !== defaultCampaignName)
      titleText.value = newVal
  }
)

const handleTemplateTitle = debounce(async (e: any) => {
  if (e.target.innerText?.trim()) {
    emit('title:update', e.target.innerText)
  }
}, 1000)

const handleClick = (task: string, key?: string) => {
  switch (task) {
    case 'back':
      emit('route:back')
      break
    case 'close':
      emit('model:close')
      break
    case 'preview':
      emit('menu:click', {
        id: 'preview_campaign',
      })
      break
    case 'menu':
      emit('menu:click', { id: key })
      break
    case 'save':
      emit('save:click')
      break
    case 'restore':
      emit('version:restore')
      break
    case 'schedule':
      emit('schedule:click')
      break
    case 'saveAsTemplate':
      emit('saveAsTemplate:click')
      break
    case 'contact-open':
      emit('contact:click')
      break
    case 'sendCampaign':
      emit('campaign:send')
      break
    case 'saveCampaign':
      emit('campaign:save')
    default:
      break
  }
}

// refs for modal header title and normal header title
const titleInput = ref()
const modalTitle = ref()

const handleEnterPress = (e: KeyboardEvent) => {
  // while pressing enter blur the title focus
  if (e.key === 'Enter') {
    if (titleInput.value) titleInput.value?.blur()
    if (modalTitle.value) modalTitle.value?.blur()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(UIContentWrap), { fullScreen: "" }, {
    default: _withCtx(() => [
      _createVNode(_unref(UIToolbar), {
        theme: "light",
        class: "h-14 hl-toolbar fonts-fallback"
      }, {
        default: _withCtx(() => [
          _createCommentVNode(" items on left "),
          _createVNode(_unref(UIToolbarGroup), {
            borderRight: "",
            class: "h-full"
          }, {
            default: _withCtx(() => [
              _createCommentVNode(" back button for modal "),
              (!__props.isModal)
                ? (_openBlock(), _createBlock(_unref(UIButton), {
                    key: 0,
                    text: "",
                    id: "back-btn",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClick('back'))),
                    class: "text-black h-full flex items-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ArrowLeftIcon), { class: "h-4 w-4 margin-r-3" }),
                      _createTextVNode(_toDisplayString(__props.backTitle), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" title for modal "),
              (__props.title && __props.isModal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", {
                      contenteditable: isBuilder.value && __props.contentEditable,
                      class: _normalizeClass(`text-lg ${!editTitle.value ? 'truncate max-w-lg' : ''}`),
                      ref_key: "modalTitle",
                      ref: modalTitle,
                      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(handleTemplateTitle) && _unref(handleTemplateTitle)(...args))),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (editTitle.value = true)),
                      onFocusout: _cache[3] || (_cache[3] = ($event: any) => (editTitle.value = false)),
                      onKeydown: handleEnterPress
                    }, _toDisplayString(titleText.value), 43 /* TEXT, CLASS, PROPS, NEED_HYDRATION */, _hoisted_2),
                    (isBuilder.value && __props.contentEditable)
                      ? (_openBlock(), _createBlock(_unref(Edit01Icon), {
                          key: 0,
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$refs?.modalTitle?.focus())),
                          class: "w-5 h-5 ml-2 text-gray-700 hover:text-gray-500"
                        }))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }),
          _createCommentVNode(" items on center "),
          _createVNode(_unref(UIToolbarGroup), { class: "flex items-center" }, {
            default: _withCtx(() => [
              _createCommentVNode(" title of builder (not modal) "),
              (
            __props.title &&
            !__props.isModal &&
            (_unref(builderState).previewUrl || _unref(builderState).unsavedChanges)
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", {
                      contenteditable: __props.contentEditable,
                      class: _normalizeClass(`text-lg ${!editTitle.value ? 'truncate max-w-lg' : ''}`),
                      onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(handleTemplateTitle) && _unref(handleTemplateTitle)(...args))),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (editTitle.value = true)),
                      onFocusout: _cache[7] || (_cache[7] = ($event: any) => (editTitle.value = false)),
                      onKeydown: handleEnterPress,
                      ref_key: "titleInput",
                      ref: titleInput
                    }, _toDisplayString(titleText.value), 43 /* TEXT, CLASS, PROPS, NEED_HYDRATION */, _hoisted_4),
                    (__props.contentEditable)
                      ? (_openBlock(), _createBlock(_unref(Edit01Icon), {
                          key: 0,
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$refs?.titleInput?.focus())),
                          class: "w-5 h-5 ml-2 text-gray-700 hover:text-gray-500"
                        }))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }),
          _createCommentVNode(" items on right "),
          (!_unref(builderState)?.mediaOpen)
            ? (_openBlock(), _createBlock(_unref(UIToolbarGroup), {
                key: 0,
                borderLeft: "",
                class: "flex items-center justify-end"
              }, {
                default: _withCtx(() => [
                  _createCommentVNode(" preview button "),
                  (currentPageName.value !== 'email_preview_template' && __props.isModal)
                    ? (_openBlock(), _createBlock(_unref(UIButton), {
                        key: 0,
                        id: "preview-btn",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (handleClick('preview'))),
                        disabled: _unref(builderState).loader
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(EyeIcon), { class: "w-5 h-5 mr-2" }),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('common.preview')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["disabled"]))
                    : _createCommentVNode("v-if", true),
                  _createCommentVNode(" menu action button "),
                  (
            (isBuilder.value || currentPageName.value === 'email_schedule_campaign') &&
            !__props.isModal &&
            _unref(builderState).previewUrl
          )
                    ? (_openBlock(), _createBlock(_unref(UIActionDropdown), {
                        key: 1,
                        id: `${__props.id}-email-builder-action-menu`,
                        options: headerMenuOptions.value,
                        onSelect: _cache[10] || (_cache[10] = val => handleClick('menu', val)),
                        placement: "bottom"
                      }, null, 8 /* PROPS */, ["id", "options"]))
                    : _createCommentVNode("v-if", true),
                  _createCommentVNode(" edit button for modal "),
                  (currentPageName.value === 'email_preview_template' && __props.isModal)
                    ? (_openBlock(), _createBlock(_unref(UIButton), {
                        key: 2,
                        id: "edit-btn",
                        type: "primary",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (handleClick('back')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Edit01Icon), { class: "w-5 h-5 mr-2" }),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('common.edit')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true),
                  _createCommentVNode(" save buttons "),
                  (
            currentPageName.value !== 'email_preview_template' &&
            __props.isModal &&
            __props.showCloneTemplate
          )
                    ? (_openBlock(), _createBlock(_unref(UIButton), {
                        key: 3,
                        id: "save-as-new-template-btn",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (handleClick('saveAsTemplate'))),
                        disabled: 
            _unref(builderState).saveAsTemplateLoading || !_unref(builderState).previewUrl
          ,
                        loading: _unref(builderState).saveAsTemplateLoading
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('emailTemplate.saveCreateNewTemplate')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["disabled", "loading"]))
                    : _createCommentVNode("v-if", true),
                  (isBuilder.value || currentPageName.value === 'email_schedule_campaign')
                    ? (_openBlock(), _createBlock(_unref(UIButton), {
                        key: 4,
                        id: "save-btn",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (
            currentPageName.value === 'email_schedule_campaign'
              ? handleClick('saveCampaign')
              : handleClick('save')
          )),
                        disabled: 
            !_unref(builderState).previewUrl &&
            !_unref(builderState).unsavedChanges &&
            currentPageName.value !== 'email_schedule_campaign'
          ,
                        loading: _unref(builderState).loader
                      }, {
                        default: _withCtx(() => [
                          (_unref(builderState).unsavedChanges && !_unref(builderState).loader)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _hoisted_8))
                            : _createCommentVNode("v-if", true),
                          _createTextVNode(" " + _toDisplayString(saveTitle.value), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["disabled", "loading"]))
                    : _createCommentVNode("v-if", true),
                  _createCommentVNode(" schedule button "),
                  (currentPageName.value === 'email_edit_campaign')
                    ? (_openBlock(), _createBlock(_unref(UIButton), {
                        key: 5,
                        id: "send-or-schedule-btn",
                        type: "primary",
                        disabled: !_unref(builderState).previewUrl && !_unref(builderState).unsavedChanges,
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (handleClick('schedule')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Send03Icon), { class: "h-5 w-5 mr-2" }),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('emailCampaign.sendOrSchedule')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["disabled"]))
                    : _createCommentVNode("v-if", true),
                  _createCommentVNode(" preview contact button "),
                  (
            ['email_preview_template', 'email_preview_campaign'].includes(
              currentPageName.value
            )
          )
                    ? (_openBlock(), _createBlock(_unref(UIButton), {
                        key: 6,
                        id: "pg-email-builder-header__preview-contact-btn",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (handleClick('contact-open')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(UserCircleIcon), { class: "w-5 h-5 mr-1" }),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('common.previewContactInfo')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true),
                  _createCommentVNode(" close icon for modal "),
                  (__props.isModal)
                    ? (_openBlock(), _createBlock(_unref(UIButton), {
                        key: 7,
                        id: "close-icon",
                        class: "h-full items-center focus:outline-none",
                        text: "",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (handleClick('close')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(XCloseIcon), { class: "w-5 h-5 text-gray-700 hover:text-gray-500" })
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true),
                  _createCommentVNode(" restore button "),
                  (
            currentPageName.value === 'email_template_version' ||
            currentPageName.value === 'email_campaign_versions'
          )
                    ? (_openBlock(), _createBlock(_unref(UIButton), {
                        key: 8,
                        id: "restore-btn",
                        loading: _unref(builderState).loader,
                        disabled: __props.disableRestore,
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (handleClick('restore')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('common.restoreVersion')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["loading", "disabled"]))
                    : _createCommentVNode("v-if", true),
                  (currentPageName.value === 'email_schedule_campaign')
                    ? (_openBlock(), _createBlock(_unref(UIButton), {
                        key: 9,
                        type: "primary",
                        id: "pg-email-builder-schedule-screen__send_campaign_btn",
                        class: "min-w-52",
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (handleClick('sendCampaign'))),
                        disabled: _unref(builderState).loader,
                        loading: _unref(builderState).sendLoader
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Send03Icon), { class: "w-6 h-6 mr-2" }),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('common.reviewAnd')) + " " + _toDisplayString(_unref(builderState).scheduleType === 'send-now'
              ? _ctx.$t('campaignSchedule.send')
              : _ctx.$t('campaignSchedule.schedule')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["disabled", "loading"]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})